import { render, staticRenderFns } from "./RedistrictingMetricsTables.vue?vue&type=template&id=05fc5729"
import script from "./RedistrictingMetricsTables.vue?vue&type=script&lang=js"
export * from "./RedistrictingMetricsTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports